import type { PairNode } from "../types";

const toPair = (source: string, index: number): PairNode => ({
  type: "pair",
  level: 0,
  label: source.slice(0, index).trim(),
  value: source.slice(index + 1).trim(),
});

const parsePair = (text: string): PairNode | null => {
  const index = text.indexOf(":");
  return index === -1 ? null : toPair(text, index);
};

const parseHtmlPair = (html: string): PairNode | null => {
  let inTag = false;
  for (let i = 0; i < html.length; i++) {
    const char = html[i];
    if (char === "<") inTag = true;
    else if (char === ">") inTag = false;
    else if (char === ":" && !inTag) return toPair(html, i);
  }
  return null;
};

export { parsePair, parseHtmlPair };
